import {useGoogleReCaptcha} from '@google-recaptcha/react';

import {config} from 'stage.config';

export const useRecaptcha = () => {
  const {executeV3} = useGoogleReCaptcha();

  const executeRecaptcha = async (): Promise<string | null> => {
    if (!executeV3) return null;
    return executeV3('login');
  };

  const getSiteKey = () => config.recaptchaSiteKey;

  return {executeRecaptcha, getSiteKey};
};
